<template>
    <div class="login">
        <div class="row">
            <div class="col logo-header">
                <router-link to="/">
                    <img src="../assets/images/logo.png" width="111px">
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h3>{{$t('recover.title')}}</h3>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-8 col-sm-4">
                <b-form-group id="email-form-group"
                              class="o-label"
                              label="Email"
                              label-for="email-input">
                    <b-form-input id="email-input"
                                  class="o-form"
                                  type="text"
                                  v-model="email"
                                  required
                                  placeholder="Email">
                    </b-form-input>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col col-8 col-sm-4">
                <b-button class="o-button"
                          v-on:click="recoverPasswordByEmail">
                    {{$t('recover.resetPasswordButton')}}
                </b-button>
            </div>
        </div>
        <div class="row justify-content-center signup-text">
            <div class="col col-8 col-sm-4 links">
                <div>
                    {{$t('signup.alreadyRegistered')}}
                    <router-link to="/login">{{$t('signup.loginAction')}}</router-link>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="language-selection">
                    <h6>
                        <a href="#" v-on:click="switchLang('de')">Deutsch</a> |
                        <a href="#" v-on:click="switchLang('en')">English</a>
                    </h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {AUTH_ACTION_RECOVER_PASSWORD, AUTH_NAMESPACE} from '../store/modules/auth-types'
    import i18n from '../assets/i18n/lang'

    export default {
        name: 'RecoverPassword',
        metaInfo () { return { title: i18n.t('recover.meta') } },
        props: {
            config: ''
        },
        data: function () {
            return {
                email: '',
                password: ''
            }
        },
        methods: {
            ...mapActions(AUTH_NAMESPACE, {
                recoverPassword: AUTH_ACTION_RECOVER_PASSWORD
            }),
            recoverPasswordByEmail () {
                this.recoverPassword({email: this.email})
            },
            switchLang: function (lang) {
                this.$i18n.locale = lang
            }
        }
    }
</script>

<style lang="scss" scoped>
    .links {
        padding-top: 20px;
        white-space: nowrap;
        text-align: center;
        font-size: 10pt;
    }

    .signup-text {
        padding-top: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/RecoverPasswordComponent.vue